import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import urls from '../../utils/constants/urls'

const BackButton = ({label, extraClass}) => {
    const navigate = useNavigate()
    const [isNavigated, setIsNavigated] = useState(false);

    useEffect(() => {
       const referrer = document.referrer;
       setIsNavigated(referrer && referrer.startsWith(window.location.origin));
    }, []);

    if (isNavigated) {
        // Navigate back to the previous page
        return <button type="button" className={`back_to_map ${extraClass ? extraClass : ''}`} onClick={() => navigate(-1)}>{label}</button>
    } else {
        // navigate directly
        return <a className={`back_to_map ${extraClass ? extraClass : ''}`} href={`${urls.basename}`}>{label}</a>
    }
}

export default BackButton;
